let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eZiOw")).then(() => parcelRequire('2KX1v'));